@if (isOpen) {
  <vw-modal
    [title]="(!showAdjust ? 'cookie.title' : 'cookie.adjustTitle') | translate"
  >
    @if (!showAdjust) {
      <p>
        <span
          class="disclaimer"
          [innerHTML]="
            'cookie.disclaimer'
              | translate
                : {
                    privacyPolicy:
                      'https://www.vwgroup.se/var-integritetspolicy/',
                  }
          "
        ></span>
        <button
          style="
            background: none;
            border: none;
            font-family: inherit;
            font-size: inherit;
            color: var(--text-link);
            padding: 0;
            text-decoration: underline;
          "
          (click)="goToAdjust()"
        >
          &nbsp;{{ "cookie.disclaimer-interactive-link" | translate }}
        </button>
        {{ "cookie.disclaimer-suffix" | translate }}
      </p>
    }
    @if (showAdjust) {
      <div>
        <vw-checkbox
          [id]="'cookie-consent-form-required'"
          [label]="'cookie.required' | translate"
          [parentForm]="cookiesForm"
          [formControlProp]="'required'"
        ></vw-checkbox>
        <p>
          {{ "cookie.requiredBody" | translate }}<br />
          <a
            [routerLink]="['/', themeService.brand || '', 'cookies']"
            [fragment]="'TABLE_REQUIRED'"
            (click)="close()"
            >{{ "cookie.readMore" | translate }}</a
          >
        </p>
        <vw-checkbox
          [id]="'cookie-consent-form-functional'"
          [label]="'cookie.functional' | translate"
          [parentForm]="cookiesForm"
          [formControlProp]="'functional'"
        ></vw-checkbox>
        <p>
          {{ "cookie.functionalBody" | translate }}<br />
          <a
            [routerLink]="['/', themeService.brand || '', 'cookies']"
            [fragment]="'TABLE_FUNCTIONAL'"
            (click)="close()"
            >{{ "cookie.readMore" | translate }}</a
          >
        </p>
        <vw-checkbox
          [id]="'cookie-consent-form-performance'"
          [label]="'cookie.performance' | translate"
          [parentForm]="cookiesForm"
          [formControlProp]="'performance'"
        ></vw-checkbox>
        <p>
          {{ "cookie.performanceBody" | translate }}<br />
          <a
            [routerLink]="['/', themeService.brand || '', 'cookies']"
            [fragment]="'TABLE_PERFORMANCE'"
            (click)="close()"
            >{{ "cookie.readMore" | translate }}</a
          >
        </p>
        <vw-checkbox
          [id]="'cookie-consent-form-marketing'"
          [label]="'cookie.marketing' | translate"
          [parentForm]="cookiesForm"
          [formControlProp]="'marketing'"
        ></vw-checkbox>
        <p>
          {{ "cookie.marketingBody" | translate }}<br />
          <a
            [routerLink]="['/', themeService.brand || '', 'cookies']"
            [fragment]="'TABLE_MARKETING'"
            (click)="close()"
            >{{ "cookie.readMore" | translate }}</a
          >
        </p>
      </div>
    }
    <ng-container actions>
      @if (!showAdjust) {
        <button
          [vw]
          class="action action__consent-min"
          [light]="true"
          (click)="consentMinimal()"
        >
          {{ "cookie.consent-minimal" | translate }}
        </button>
        <button
          [vw]
          class="action action__adjust"
          [primary]="true"
          (click)="goToAdjust()"
        >
          {{ "cookie.adjust" | translate }}
        </button>
        <button
          [vw]
          class="action action__consent-all"
          [light]="true"
          (click)="consentAll()"
        >
          {{ "cookie.consent-all" | translate }}
        </button>
      }
      @if (showAdjust) {
        <button
          [vw]
          class="action action__save"
          type="button"
          [primary]="true"
          (click)="consentForm()"
        >
          {{ "cookie.save" | translate }}
        </button>
      }
    </ng-container>
  </vw-modal>
}
